var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.602,
    height: 43.565,
    viewBox: "0 0 43.602 43.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.152,47.747H17.9a2.9,2.9,0,0,1-2.9-2.9V18.488a2.9,2.9,0,0,1,2.9-2.9H53.152a2.9,2.9,0,0,1,2.9,2.9V44.847A2.9,2.9,0,0,1,53.152,47.747Z",
    transform: "translate(-13.723 -14.309)",
    fill: "#e6f7ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.677,15.588H256.044V47.747h17.633a2.9,2.9,0,0,0,2.9-2.9V18.488a2.9,2.9,0,0,0-2.9-2.9Z",
    transform: "translate(-234.248 -14.309)",
    fill: "#c3e9fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.041,401.674l1.388-8.856h11.314l1.246,8.855Z",
    transform: "translate(-158.31 -359.38)",
    fill: "#004db6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.044,401.679h6.882l-1.246-8.855h-5.636Z",
    transform: "translate(-234.248 -359.385)",
    fill: "#192b80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.239 23.408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.935,275.17a.95.95,0,0,1-.132-.01V282c0,2.728,1.607,4.374,4.128,4.374H42.146c2.2,0,3.772-1.5,3.772-4.374V275.17Z",
    transform: "translate(-2.803 -275.16)",
    fill: "#7affe4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.424 41.008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.927,484.166h-20.2a1.279,1.279,0,0,1,0-2.558h20.2a1.279,1.279,0,0,1,0,2.558Z",
    transform: "translate(-122.449 -481.608)",
    fill: "#0089ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.066,286.474H273.85c2.2,0,3.772-1.5,3.772-4.374v-6.827H256.066Z",
    transform: "translate(-234.268 -251.856)",
    fill: "#00ddc1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.149,481.608h-10.1v2.558h10.1a1.279,1.279,0,0,0,0-2.558Z",
    transform: "translate(-234.248 -440.6)",
    fill: "#295fcc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.767,35.305H3.836A3.838,3.838,0,0,1,0,31.464V4.429A3.838,3.838,0,0,1,3.836.588H39.767A3.838,3.838,0,0,1,43.6,4.429V31.464a3.838,3.838,0,0,1-3.836,3.841ZM3.836,3.146A1.283,1.283,0,0,0,2.554,4.429V31.464a1.283,1.283,0,0,0,1.282,1.284H39.767a1.283,1.283,0,0,0,1.282-1.284V4.429a1.283,1.283,0,0,0-1.282-1.284H3.836Z",
    transform: "translate(0 -0.588)",
    fill: "#0089ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.336.588H256.044V3.146h18.292a.961.961,0,0,1,.96.961V31.384a1.363,1.363,0,0,1-1.362,1.364h-17.89v2.558h18.292a3.516,3.516,0,0,0,3.514-3.519V4.107A3.516,3.516,0,0,0,274.336.588Z",
    transform: "translate(-234.248 -0.588)",
    fill: "#295fcc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.752 5.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.318,65.711h-8.531a1.279,1.279,0,0,1,0-2.558h8.531a1.279,1.279,0,0,1,0,2.558Z",
    transform: "translate(-302.51 -63.153)",
    fill: "#00337a"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.752 10.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.318,135.033h-8.531a1.278,1.278,0,0,1-1.277-1.279v-7.721a1.278,1.278,0,0,1,1.277-1.279h8.531a1.278,1.278,0,0,1,1.277,1.279v7.721A1.278,1.278,0,0,1,312.318,135.033Zm-7.255-2.558h5.978v-5.163h-5.978Z",
    transform: "translate(-302.51 -124.755)",
    fill: "#1766a0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.446 5.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.418,76.3H86.2V89.238H74.418Z",
    transform: "translate(-72.529 -75.176)",
    fill: "#ffed00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.548,78.683a1.265,1.265,0,0,1-.894-.37L52.615,65.37a1.3,1.3,0,0,1-.018-1.828,1.266,1.266,0,0,1,1.806-.018L67.442,76.467A1.3,1.3,0,0,1,67.46,78.3,1.265,1.265,0,0,1,66.548,78.683Z",
    transform: "translate(-52.232 -63.153)",
    fill: "#ff405c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.509,78.683A1.265,1.265,0,0,1,52.6,78.3a1.3,1.3,0,0,1,.018-1.828L65.654,63.523a1.266,1.266,0,0,1,1.806.018,1.3,1.3,0,0,1-.018,1.828L54.4,78.313A1.264,1.264,0,0,1,53.509,78.683Z",
    transform: "translate(-52.232 -63.153)",
    fill: "#ff405c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.548,78.684H53.509a1.285,1.285,0,0,1-1.277-1.293V64.447a1.285,1.285,0,0,1,1.277-1.293H66.548a1.285,1.285,0,0,1,1.277,1.293V77.391A1.285,1.285,0,0,1,66.548,78.684ZM54.786,76.1H65.271V65.74H54.786Z",
    transform: "translate(-52.232 -63.154)",
    fill: "#ff405c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroDesktop);
export default __webpack_public_path__ + "static/media/Asset-KuroDesktop.dc616f6db80b5859356473e701c5198a.svg";
export { ForwardRef as ReactComponent };